import { type CSSProperties } from 'typestyle/lib/types';
import StyleConstants from '../../core/styles.constants';

export const bottomMargin: CSSProperties = {
  marginBottom: 24,
  paddingBottom: 24,
};

export const gridRow: CSSProperties = {
  marginTop: 12,
};

export const cornerButton = (isMobile = false): CSSProperties => ({
  marginLeft: isMobile ? 12 : 56,
  marginRight: isMobile ? 12 : 56,
  marginTop: isMobile ? 78 : 25,
});

export const rowItem = (isLastItem = false): CSSProperties => ({
  marginBottom: isLastItem ? 0 : 12,
  width: '100%',
});

export const emptyListMessage: CSSProperties = {
  marginTop: 16,
  wordBreak: 'break-word',
  lineBreak: 'strict',
  fontSize: StyleConstants.CARD_BODY_FONT_SIZE,
  fontWeight: StyleConstants.CARD_BODY_FONT_WEIGHT,
  fontFamily: StyleConstants.PRIMARY_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
};

export const columnHeader = (isMobile: boolean, marginBottom?: number): CSSProperties => ({
  wordBreak: 'break-word',
  textAlign: isMobile ? 'center' : undefined,
  fontSize: StyleConstants.HEADER_FONT_SIZE,
  fontWeight: StyleConstants.HEADER_FONT_WEIGHT,
  fontFamily: StyleConstants.HEADER_FONT_FAMILY,
  color: StyleConstants.GREY_COLOR,
  marginBottom,
});
